export default __webpack_public_path__ + "static/media/A673.6d8eb02a.webp";